/* eslint-disable */
import React, { FC, ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import withLocalization from '../../components/hoc/withLocalization';
import OfferHeader from '../../components/common/OfferHeader/OfferHeader';
import OrderSummaryDetails from '../../components/OrderSummaryDetails/OrderSummaryDetails';
import { useMediaQuery } from 'react-responsive';
import ThankYouDetailsPage from '../../components/ThankYouDetailsPage/ThankYouDetailsPage';
import { RootState } from '../../redux/rootReducer';
import { clearPayerAuthDetails } from '../OfferPaymentContainer/OfferPaymentSlice';

import './NewOfferThankYou.scss';

const NewOfferThankYou: FC<any> = (props: any): ReactElement => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  const navigate = useNavigate();
  const prospectDetails: any = useSelector((state: RootState) => state.offerDetails.prospect);
  const pinOfferDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const pinOfferData: any = (pinOfferDetails?.offers && pinOfferDetails?.offers[0]) || {};
  const offerDetails = pinOfferData;
  const getofferPhone: any = offerDetails?.offerPhoneNumber || prospectDetails?.callCenterNumber;

  const PhoneNo = pinOfferData?.offerPhoneNumber || '';
  const errPhoneNo = getofferPhone ? getofferPhone : '';

  const receiveOfferLoc = offerDetails?.loc || '';
  const errDetails = {
    errPhNo: errPhoneNo || '',
    callCenterCode: prospectDetails?.callCenterCode,
    countryName: prospectDetails?.countryCode,
  };
  useEffect(() => {
    dispatch(clearPayerAuthDetails());
  }, [dispatch]);
  if (!receiveOfferLoc) {
    navigate('/error', { state: errDetails });
  }
  return (
    <>
      <OfferHeader phone={PhoneNo} isThankyou={true} />
      <div className="tmvc-thankYou-main-container">
        <div className="thankYou-info-page-container">
          <ThankYouDetailsPage />
          {/* {!isMobile && <TravelInspiration />}*/}
        </div>
        <OrderSummaryDetails />
        {isMobile && (
          <div className="thankYou-info-page-container">
            {/*
            Todo work on future 
            <TravelInspiration />
            */}
          </div>
        )}
      </div>
    </>
  );
};
export default withLocalization(NewOfferThankYou);
